export const AFFILIATES_BASE = "affiliatesBase";
